import Logger from 'app/services/Logger';
import { LogData } from 'app/services/Logger.types';
import { OneTrustConfig } from 'app/services/OneTrust.types';

const MODULE = `[OneTrust]`;

const OneTrust: OneTrustConfig = {
  onConsentChanged(callback) {
    if (!window?.OneTrust) return;

    try {
      window.OneTrust.OnConsentChanged(() => {
        callback?.();
      });
    } catch (err: unknown) {
      Logger.error(`${MODULE} Failed to register consent listener:`, err as LogData);
    }
  },

  openConsentPreferences() {
    if (!window?.OneTrust) return;

    try {
      window.OneTrust.ToggleInfoDisplay();
    } catch (err: unknown) {
      Logger.error(`${MODULE} Failed to open consent preferences:`, err as LogData);
    }
  },
};

export default OneTrust;
